import * as _4 from 'lodash4';
import { PollQueryModel } from '../../../queries/poll_query_model';
import { PollResultsQueryModel } from '../../../queries/poll_results_query_model';
import { PollPlatformServant } from './../../../servants/poll_platform_servant';

export class PollResultsController {
  public favCallback: (resource: any) => void;

  constructor(
    private $state: any,
    private ngPollQueryModel: PollQueryModel,
    private ngPollResultsQueryModel: PollResultsQueryModel,
    private ngPollPlatformServant: PollPlatformServant
  ) {
    this.favCallback = (resource: any): void => undefined;
  }

  hasResources(): boolean {
    return _4.get(this.ngPollResultsQueryModel.resultsPageFlags, 'hasResources', false);
  }

  shouldShowResults(): boolean {
    return _4.get(this.ngPollResultsQueryModel.resultsPageFlags, 'showResults', false);
  }

  /**
   * @deprecated not called anymore
   */
  getBrandingTint(): string {
    return `color:var(--hi-clr--university-3);`;
  }
}



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-poll/src/components/results/poll_results/poll_results_controller.ts